import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Box, Container, Grid, Typography } from "@mui/material";

const Footer = () => {
  const theme = useTheme();
  const currentDate = new Date();
const currentYear = currentDate.getFullYear();
  return (
    <Box sx={{ p: 1.5 }}>
      <Container maxWidth="xl">
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs="auto">
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              spacing={2}
            >
              <Grid item xs="auto">
                <Typography variant="base" color="text.main">
                  {/* &copy; 2023, Develop by{" "} */}
                  <span style={{ color: theme.palette.primary.main }}>
                    &copy; {currentYear} CertifyMyID 2.0.1
                  </span>
                </Typography>
              </Grid>
              {/* <Grid item xs="auto">
                <Typography variant="base" color="primary.main">
                  Version 2.5.1
                </Typography>
              </Grid> */}
            </Grid>
          </Grid>
          <Grid item xs="auto">
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              spacing={2}
            >
              <Grid item xs="auto">
                <Typography variant="base" color="text.main">
                  Privacy Policy
                </Typography>
              </Grid>
              <Grid item xs="auto">
                <Typography variant="base" color="text.main">
                  Support
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
